// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"412":"23ab52ed","739":"5e09f83e"}[chunkId] + ".chunk.js";
};